import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import UserGuideModal from './UserGuideModal';

import ContactSupportModal from './ContactSupportModal';
import FAQsModal from './FAQsModal';

const HelpSupportSection = () => {
  const [activeModal, setActiveModal] = useState(null);

  const helpItems = [
    {
      icon: 'BookOpen',
      title: 'User Guide',
      description: 'Learn how to use all features',
      action: 'View Guide',
      modalKey: 'userGuide'
    },
    {
      icon: 'MessageCircle',
      title: 'Contact Support',
      description: 'Get help from our team',
      action: 'Contact Us',
      modalKey: 'contactSupport'
    },
    {
      icon: 'HelpCircle',
      title: 'FAQs',
      description: 'Find answers to common questions',
      action: 'View FAQs',
      modalKey: 'faqs'
    }
  ];

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        {helpItems?.map((item, index) => (
          <button
            key={index}
            onClick={() => setActiveModal(item?.modalKey)}
            className="
              flex items-start gap-3 sm:gap-4 p-4 sm:p-5 rounded-lg
              bg-muted/50 border border-border
              hover:bg-muted hover:border-primary/30 hover:shadow-therapeutic
              transition-smooth text-left
              focus:outline-none focus:ring-3 focus:ring-ring
              active:scale-[0.98]
            "
            aria-label={item?.action}
          >
            <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-primary/10 flex-shrink-0">
              <Icon name={item?.icon} size={20} color="var(--color-primary)" strokeWidth={2} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm sm:text-base font-semibold text-foreground mb-1">
                {item?.title}
              </h3>
              <p className="text-xs sm:text-sm text-muted-foreground mb-2">
                {item?.description}
              </p>
              <span className="text-xs sm:text-sm text-primary font-medium inline-flex items-center gap-1">
                {item?.action}
                <Icon name="ArrowRight" size={14} strokeWidth={2} />
              </span>
            </div>
          </button>
        ))}
      </div>

      {/* Modals */}
      <UserGuideModal
        isOpen={activeModal === 'userGuide'}
        onClose={() => setActiveModal(null)}
      />
      <ContactSupportModal
        isOpen={activeModal === 'contactSupport'}
        onClose={() => setActiveModal(null)}
      />
      <FAQsModal
        isOpen={activeModal === 'faqs'}
        onClose={() => setActiveModal(null)}
      />
    </>
  );
};

export default HelpSupportSection;